import type { MeetCapabilityDto } from '@shared/core/appointment-types'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_MEET_CAPABILITY_CACHE_KEY = 'get-meet-capability'

/** `cacheTime: 0` drops an answer once no form reads it, so a reopened form never shows the last open's answer. */
export function useMeetCapability(calendarId: string, options?: UseQueryOptions<MeetCapabilityDto>) {
  const handleRetry = useHandleRetry()

  return useQuery(
    [GET_MEET_CAPABILITY_CACHE_KEY, calendarId],
    () => ApiService.AppointmentTypes.getMeetCapability(calendarId),
    {
      enabled: Boolean(calendarId),
      staleTime: 0,
      cacheTime: 0,
      retry: handleRetry,
      ...options,
    },
  )
}
